// CHRIS · C1 — Zentrale, tunbare Konfiguration (keine Magic Numbers verstreut).
// Verwendet AUSSCHLIESSLICH die eingefrorenen Produktionsassets v1.0
// (frontend/public/chris/v1/production). Assets werden NICHT verändert.

export const ASSET_BASE = "/chris/v1/production";

// Alle 10 gesperrten Posen (für Preload + Referenz).
export const POSE_SLUGS = [
  "01_chris_home_sit",
  "02_chris_stand_up",
  "03_chris_walk_left",
  "04_chris_walk_mid",
  "05_chris_walk_right",
  "06_chris_arrive",
  "07_chris_target_sit",
  "08_chris_point",
  "09_chris_wait",
  "10_chris_thumbs_up",
];

export const srcFor = (slug) => `${ASSET_BASE}/${slug}.png`;

// Walk-Zyklus (verbindlich): 03 → 04 → 05 → 04 → …
export const WALK_FRAMES = [
  "03_chris_walk_left",
  "04_chris_walk_mid",
  "05_chris_walk_right",
  "04_chris_walk_mid",
];

// Semantische Figuranker als Bruchteil der 1024×1536-Canvas. KOPF-Anker-Modell:
// ax = horizontaler Kopf-Pivot, ay = Kopf-Oberkante (aus Alpha-Vermessung).
// Kopf-Ankerung hält den Kopf stabil auf einer Linie → kein vertikales Springen
// zwischen Posen, und der Registrierungspunkt kann garantiert im Viewport bleiben.
export const ANCHORS = {
  "01_chris_home_sit": { ax: 0.5, ay: 0.16 },
  "02_chris_stand_up": { ax: 0.5, ay: 0.16 },
  "03_chris_walk_left": { ax: 0.5, ay: 0.14 },
  "04_chris_walk_mid": { ax: 0.5, ay: 0.14 },
  "05_chris_walk_right": { ax: 0.5, ay: 0.14 },
  "06_chris_arrive": { ax: 0.5, ay: 0.14 },
  "07_chris_target_sit": { ax: 0.5, ay: 0.14 },
  "08_chris_point": { ax: 0.52, ay: 0.17 },
  "09_chris_wait": { ax: 0.5, ay: 0.15 },
  "10_chris_thumbs_up": { ax: 0.5, ay: 0.13 },
};

// Darstellungsgröße (Canvas-Höhe in px). Breite = Höhe × 1024/1536.
export const SIZES = {
  desktopHeight: 140,
  mobileHeight: 110,
  ratio: 1024 / 1536,
  breakpointLg: 1024,
};

// Timings (ms bzw. px/s) — zentral, damit nach Sichtprüfung leicht justierbar.
export const TIMINGS = {
  homeSettle: 400,
  standUpDuration: 550,
  walkSpeed: 240, // px pro Sekunde (Translation über die Oberfläche)
  walkFrameInterval: 150, // Frame-Wechsel im Walk-Zyklus
  arriveDuration: 500,
  sitDuration: 450,
  pointDuration: 700,
  messageDuration: 2600, // Sprechblase sichtbar
  waitDuration: 1200,
  returnStandUp: 500,
  readyDuration: 420, // Stillstand nach dem Aufstehen (READY_TO_WALK / READY_TO_RETURN)
  arriveHomeDuration: 420, // Stabilisierung am Logo vor dem Hinsetzen
};

// Home-Anker relativ zum GEMESSENEN Logo (kein Hardcoding einer Bildschirmposition).
// Desktop: Chris hat seinen Stammplatz RECHTS neben dem Logo im weißen Sidebar-
// Kopfbereich (verdeckt weder Logo noch Unternehmensname). Mobile: am Logo-Icon.
export const HOME = {
  desktopDx: 16, // horizontaler Abstand rechts von der Logo-Rechtskante (px)
  desktopHeadDy: 2, // Kopf-Oberkante ~ Logo-Oberkante
  margin: 12, // Sicherheitsabstand zur Sidebar-Rechtskante
  mobileFracX: 0.5,
  mobileDyHead: 6,
};

// Ziel-Positionierung relativ zum GEMESSENEN WK-Button. Chris SITZT auf der
// oberen (linken) Kante des Buttons: sein Gesäß (seatFrac) liegt auf der
// Button-Oberkante, die Beine baumeln über die Kante. Der Button-Text bleibt
// frei. pointRef.y bleibt die Kopf-Oberkante (Kopf-Anker), daher wird der Kopf
// entsprechend höher gesetzt. Horizontal + vertikal in den Viewport geklemmt.
export const TARGET = {
  margin: 8,
  minHeadY: 10, // Kopf-Oberkante bleibt im Viewport (kein Top-Clipping)
  perchInsetX: 26, // Sitz-X = linke Buttonkante + Inset → Chris sitzt DEUTLICH auf dem Button (Betreiberwunsch, leichte Textüberlagerung akzeptiert)
  seatFrac: 0.6, // Gesäß-Kontakt als Anteil der Figurhöhe → auf Buttonkante
  aboveGap: 10, // "above"-Modus: Abstand der Füße über der Ziel-Oberkante (px)
};

// READY-Stand: 06_chris_arrive ist die einzige VOLLSTÄNDIG AUFRECHTE Standpose
// unter den 10 eingefrorenen Assets (02_stand_up ist nur der hockende Aufsteh-
// Übergang). Sie wird als Bereitschaftspose vor dem Loslaufen verwendet.
export const READY_POSE = "06_chris_arrive";

// Klassische Comic-Sprechblase (weiß, Navy-Kontur, deutlich gerundet, mit
// sichtbarem Schwanz Richtung Chris). Position wird zur Laufzeit vollständig in
// den Viewport geklemmt; darf zweizeilig umbrechen.
export const BUBBLE = {
  gap: 16, // Abstand Blase↔Kopf (inkl. Platz für den Schwanz)
  maxWidth: 300,
  tailSize: 13, // Höhe des Sprechblasen-Schwanzes (px)
  borderWidth: 2,
  radius: 18,
};

// Sanfter Laufbogen (optisch angenehmer als eine schnurgerade Linie).
export const ARC = { fraction: 0.12, maxPx: 26 };

export const MESSAGE_TEXT = "Hier warten Wirksamkeitskontrollen auf Sie.";

// Bewusst gewählt: über der Mobile-Topbar (z-40), unter Radix-Dialogen (z-50).
export const Z_INDEX = 45;

export const TARGET_TESTID = "wirksamkeit-pruefen-button";
export const LOGO_DESKTOP_TESTID = "app-logo-sidebar";
export const LOGO_MOBILE_TESTID = "app-logo-mobile";
export const SIDEBAR_TESTID = "unternehmer-sidebar";

// CHRIS · C3 — Freigegebene Handlungstrigger (Reihenfolge = PRIORITÄT).
// Positioniermodus: "perch" = auf der Zielkante sitzen (eingefrorenes WK-
// Verhalten); "above" = über dem Ziel stehen und nach unten zeigen (Sidebar-
// Menüpunkt). Reicht der Platz über dem Ziel nicht, sitzt Chris ersatzweise auf
// dem Ziel (Betreiber-Fallback). "überfällig" ist bei EV-012 als Chris-Wortwahl
// ausdrücklich VERBOTEN. Plural-Copy aggregiert (ein Hinweis statt pro Datensatz).
// Cooldowns (BE-final): EV-012=30 T, EV-020_021=7 T, EV-032=30 T, EV-003=7 T.
export const CHRIS_EVENTS = [
  {
    key: "EV-012",
    testIdDesktop: "wirksamkeit-pruefen-button",
    testIdMobile: "wirksamkeit-pruefen-button",
    mode: "perch",
    cooldownDays: 30,
    message: (n) =>
      n <= 1
        ? "Eine Wirksamkeitskontrolle wartet auf Ihre Prüfung."
        : "Mehrere Wirksamkeitskontrollen warten auf Ihre Prüfung.",
  },
  {
    key: "EV-020_021",
    testIdDesktop: "nav-fuehrerschein",
    testIdMobile: "nav-fuehrerschein-icon-badge-mobile",
    mode: "above",
    scrollIntoView: true,
    cooldownDays: 7,
    message: (n) =>
      n <= 1
        ? "Eine Führerscheinkontrolle wartet auf Ihre Prüfung."
        : `${n} Führerscheinkontrollen warten auf Ihre Prüfung.`,
  },
  {
    key: "EV-032",
    testIdDesktop: "hsp-dashboard-hinweis",
    testIdMobile: "hsp-dashboard-hinweis",
    mode: "perch",
    cooldownDays: 30,
    message: (n) =>
      n <= 1
        ? "Ein Hautschutzplan sollte wieder geprüft werden."
        : `${n} Hautschutzpläne sollten wieder geprüft werden.`,
  },
  {
    key: "EV-003",
    testIdDesktop: "stat-ueberfaellig",
    testIdMobile: "stat-ueberfaellig",
    mode: "perch",
    cooldownDays: 7,
    message: (n) =>
      n <= 1
        ? "1 Mitarbeiter sollte auf seine fälligen Unterweisungen angesprochen werden."
        : `${n} Mitarbeiter sollten auf ihre fälligen Unterweisungen angesprochen werden.`,
  },
];

// Auslöser-Steuerung: Chris bewertet die Trigger NUR auf dem Dashboard (dort sind
// alle Zielanker erreichbar). Rückkehr ins Dashboard = neue Bewertung.
export const TRIGGER = {
  dashboardPath: "/unternehmer",
  settleMs: 1500, // Dashboard-Daten + Zielanker rendern lassen
  retryMs: 800,
  maxRetries: 3,
  // C3-Fix: Zeitfenster (ms) nach Chris' eigenem scrollIntoView, in dem der
  // globale Scroll-Abbruch das programmatische Scroll-Event ignoriert.
  scrollSuppressMs: 700,
};
